import React from 'react';
import PropTypes from 'prop-types';

const CheckBoxInput = (props) => {
  const handleChange = (e) => {
    props.onChange(props.name,
      e.target.checked);
  };
  /* eslint-disable no-unused-vars */
  const {value, onChange, ...properties} = props;
  /* eslint-enable no-unused-vars */
  return (
    <span className="checkbox">
      <input
        checked={!!value}
        id={props.name}
        onChange={handleChange}
        /* connection with label works only through id */
        type="checkbox"
        {...properties}
      />
      <label htmlFor={props.name}>
        <i className="fa fa-check" />
      </label>
    </span>
  );
};

CheckBoxInput.PropTypes = {
  name:PropTypes.string.isRequired,
  onChange:PropTypes.func.isRequired,
  value:PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
};

export default CheckBoxInput;
